export default __webpack_public_path__ + "static/core-pic-645277ff3dd2d7a62b674071a75c422e.png";